import { render } from "./PlaybookProposalModal.vue?vue&type=template&id=0b315f6c"
import script from "./PlaybookProposalModal.vue?vue&type=script&lang=js"
export * from "./PlaybookProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlaybookProposalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b315f6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b315f6c', __exports__)) {
    api.reload('0b315f6c', __exports__)
  }
  
  module.hot.accept("./PlaybookProposalModal.vue?vue&type=template&id=0b315f6c", () => {
    api.rerender('0b315f6c', render)
  })

}


export default __exports__